import React from 'react';
import type { V2Route } from '../units/types';

const routes: V2Route[] = [
  { path: 'plans', Component: React.lazy(() => import('./PlansPage')), layout: 'focus' },
  { path: 'credits/purchase/success', Component: React.lazy(() => import('./CreditPurchaseSuccessPage')), layout: 'focus' },
  { path: 'credits/purchase/cancel', Component: React.lazy(() => import('./CreditPurchaseCancelPage')), layout: 'focus' },
];

export default routes;
